module.exports = __webpack_public_path__ + "media/images/close-icon-ai-95fec169.png";